import { createSelector } from '@reduxjs/toolkit'
import { getWebinars } from 'model/selectors/base'
import orderBy from 'lodash/orderBy'

export const getSortedWebinars = createSelector([getWebinars], webinars => {
  return orderBy(webinars, 'createdAt', 'desc')
})
